import apiClient from '@shared/api/client'
import { ENDPOINTS } from '@shared/api/endpoints'
import { getStoredLanguage } from '@shared/i18n'
import { mockApiClient } from './transmissionAreaMock'

/**
 * 中台心傳活動的 event_id（用於 banner listByEvent）
 */
const TRANSMISSION_BANNER_EVENT_ID = 4

/**
 * 中台心傳精舍影片的 event_id（用於 behindScenes list）
 */
const TRANSMISSION_EVENT_ID = 5

/**
 * 聯展影片的 event_id（用於 behindScenes list）
 */
const JOINT_EXHIBITION_EVENT_ID = 4

/**
 * 取得中台心傳展區列表（含精舍）
 * POST /v1/exhibition/area/list
 */
export async function getAreaList(params = {}) {
  return apiClient.post('/v1/exhibition/area/list', params)
}

/**
 * 取得中台心傳 Banner（單張，僅使用 subtitle/content）
 * POST /v1/member/banner/listByEvent
 * 後端目前未提供 _en 欄位，待補上後這裡會自動生效
 */
export async function getTransmissionBanner() {
  const res = await apiClient.post(ENDPOINTS.BANNER.LIST_BY_EVENT, { event_id: TRANSMISSION_BANNER_EVENT_ID }, { skipLang: true })
  const isEn = getStoredLanguage() === 'en'
  if (isEn && res.media) {
    res.media = res.media.map(item => ({
      ...item,
      details: item.details ? {
        ...item.details,
        title: item.details.title_en || item.details.title,
        subtitle: item.details.subtitle_en || item.details.subtitle,
        content: item.details.content_en || item.details.content,
      } : item.details,
    }))
  }
  return res
}

/**
 * 取得中台心傳區域列表
 * POST /v1/exhibition/region/list
 */
export async function getRegionList(params = {}) {
  return apiClient.post('/v1/exhibition/region/list', params)
}

/**
 * 取得中台心傳花絮列表
 * POST /v1/event/behindScenes/list
 * event_id = 5 (中台心傳專屬)
 */
export async function getBehindScenesList(params = {}) {
  return apiClient.post(ENDPOINTS.BEHIND_SCENES.LIST, { event_id: TRANSMISSION_EVENT_ID, ...params })
}

/**
 * 取得聯展影片列表
 * POST /v1/event/behindScenes/list
 * event_id = 4 (聯展影片專屬)
 */
export async function getJointExhibitionVideoList(params = {}) {
  return apiClient.post(ENDPOINTS.BEHIND_SCENES.LIST, { event_id: JOINT_EXHIBITION_EVENT_ID, ...params })
}

/**
 * 取得單一精舍心傳詳情
 * POST /v1/exhibition/post/list with monastery_id + show_detail
 */
export async function getPostDetail(monasteryId) {
  return apiClient.post('/v1/exhibition/post/list', {
    monastery_id: parseInt(monasteryId, 10),
    show_detail: true,
  })
}

export async function getAreaDetail(areaId, templateId) {
  const params = { area_id: parseInt(areaId, 10) }
  if (templateId) params.template_id = parseInt(templateId, 10)
  return mockApiClient.area_detail(params)
}

/**
 * 中台心傳按讚（只能讚不能取消讚，後端限制一天最多 5 篇，UTC 00:00 重算）
 * POST /v1/exhibition/post/like
 */
export async function likeExhibitionPost(postId) {
  return apiClient.post(ENDPOINTS.EXHIBITION.POST_LIKE, {
    post_id: postId,
    like: true,
  })
}

/**
 * 取得地圖點位（coordinate_id）對應精舍（monastery_id）的關係列表
 * POST /v1/exhibition/coordinate/list
 */
export async function getCoordinateList(params = {}) {
  return apiClient.post(ENDPOINTS.EXHIBITION.COORDINATE_LIST, params)
}
